import { useMemo } from "react";
import { materialTheme, materialThemeDark } from "@coretex/lego";
import { createTheme } from "@material-ui/core";
import { ThemeProvider as MUIThemeProvider } from "@material-ui/core/styles";

import { eroadTheme } from "@eroad/ui-library/eroadTheme";
import { ThemeProvider as UiLibraryThemeProvider } from "@eroad/ui-library/ThemeProvider";

const ThemeProvider = ({ children }: React.PropsWithChildren<object>) => {
  const darkMode = false;

  const theme = useMemo(() => createTheme(darkMode ? materialThemeDark : materialTheme), [darkMode]);

  return (
    <UiLibraryThemeProvider theme={eroadTheme}>
      <MUIThemeProvider theme={{ ...eroadTheme, ...theme }}>{children}</MUIThemeProvider>
    </UiLibraryThemeProvider>
  );
};

export { ThemeProvider };
